var _excluded = ["id", "status", "surfaceColor", "label", "disabled", "autotagging-flora", "data-autotagging-flora-section", "data-flora-text", "aria-label"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { forwardRef } from '@grupoboticario/flora-react-system';
import { StyledSwitchInput, StyledSwitchWrapper, StyledSwitchLabel, StyledFloraSwitch, StyledCrossCircleIcon, StyledCheckCircleIcon } from './styles';
import { useFloraSwitch } from './useFloraSwitch';
/**
 * @component
 * @name Switch
 * @description Elemento gráfico interativo que possibilita ativar ou desativar uma função, alterando seu estado entre ligado e desligado, através de um simples toque ou clique. É utilizado em interfaces de aplicativos e sites para fornecer controle intuitivo sobre diferentes opções e configurações.
 * @tutorial https://florabook.gb.tech/v2/index.html?path=/docs/core-components-switch--default
 */

export var FloraSwitch = forwardRef((_ref, forwardedRef) => {
  var {
    id,
    status = 'neutral',
    surfaceColor = 'light',
    label,
    disabled,
    'autotagging-flora': autotaggingFlora = 'off',
    'data-autotagging-flora-section': dataAutotaggingFloraSection = '',
    'data-flora-text': dataFloraText,
    'aria-label': ariaLabel
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var {
    ref,
    isChecked
  } = useFloraSwitch({
    id,
    forwardedRef
  });
  return /*#__PURE__*/React.createElement(StyledSwitchWrapper, {
    htmlFor: id,
    disabled: Boolean(disabled)
  }, /*#__PURE__*/React.createElement(StyledSwitchInput, _extends({}, props, {
    id: id,
    ref: ref,
    as: "input",
    "data-flora": "switch",
    "autotagging-flora": autotaggingFlora,
    "data-flora-text": dataFloraText || ariaLabel || label,
    "data-autotagging-flora-section": dataAutotaggingFloraSection,
    type: "checkbox",
    surfaceColor: surfaceColor,
    status: status,
    disabled: disabled,
    "aria-label": ariaLabel != null ? ariaLabel : label,
    "aria-invalid": status === 'error',
    "aria-checked": isChecked,
    role: "switch"
  })), /*#__PURE__*/React.createElement(StyledFloraSwitch, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledCheckCircleIcon, {
    "data-icon": "check-circle-icon",
    css: {
      opacity: isChecked ? 1 : 0
    }
  }), /*#__PURE__*/React.createElement(StyledCrossCircleIcon, {
    "data-icon": "cross-circle-icon",
    css: {
      opacity: !isChecked ? 1 : 0
    }
  }))), /*#__PURE__*/React.createElement(StyledSwitchLabel, {
    "aria-hidden": true,
    surfaceColor: surfaceColor
  }, label));
});
//# sourceMappingURL=FloraSwitch.js.map